import React, { useState } from 'react'
import Img from "gatsby-image"
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption
} from 'reactstrap';

const Slider = ({ banners, sources }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === banners.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  }

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? banners.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  }

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  }

  const slides = banners.map((item) => {
    return (
      <CarouselItem
        className="custom-tag"
        tag="div"
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
        {item.link ?
          <a href={item.link} target={item.scroll ? "" : "_blank"} className="slider_link" target="_blank">
            {/* <Img className="main-slider" fluid={sources[item.src]} alt={item.altText} /> */}
            <img className="main-slider" src={item.src} alt={item.altText} />
          </a>
          :
          // <Img className="main-slider" fluid={sources[item.src]} alt={item.altText} />
          <img className="main-slider" src={item.src} alt={item.altText} />
        }

        {item.product ?
          <div class="main-slider_caption">
            <div class="carousel-caption d-none ipp-pad">
              <h3>{item.product}<span class="prod-name-italic">Now</span> Car Insurance</h3>
              <p>{item.caption}</p>
              <div><img className="ipp" src={"/cimb/staff/images/img-instalment_header.svg"} alt="instalment plan" /></div>
            </div>
          </div> :
          <div class="main-slider_caption">
            <div class="carousel-caption">
              <h3>{item.product}<span class="prod-name-italic">Now</span></h3>
              <p>{item.caption}</p>
            </div>
          </div>}

        {item.header ?
          <div class="main-slider_caption">
            <div class="carousel-caption d-none ">
              <h3>{item.header}</h3>
              <p>{item.caption}</p>
            </div>
          </div> :
          <div class="main-slider_caption">
            <div class="carousel-caption">
              <h3>{item.product}<span class="prod-name-italic">Now</span></h3>
              <p>{item.caption}</p>
            </div>
          </div>}
      </CarouselItem>
    );
  });

  return <div>
    <Carousel
      activeIndex={activeIndex}
      next={next}
      previous={previous}
    >
      {/* <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} /> */}
      {slides}
      <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
      <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
    </Carousel>
  </div>
}

export default Slider